import { useEffect, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { TagManager } from "@dealer-center/core-third-party-gtm";
import { useGetUser } from "@dealer-center/ddc-api-user-fetch";
import { useControlcenterAPIInterface } from "@dealer-center/ddc-pages-controlcenter-fetch";
import { MessagePage } from "@dealer-center/core-custom-components";
import { ControlCenterContainer } from "./components/ControlCenterContainer";
import { Locale } from "@dealer-center/ddc-core-utils";
import LABELS from "./labels.json";

// Relative to <base href="/landing/"> — resolves to /landing/dc-favicon.ico in both dev and prod.
// Do not use an absolute path (/dc-favicon.ico) as that would bypass the app's baseHref.
const DC_FAVICON_PATH = "dc-favicon.ico";

export const PagesControlcenterApp = () => {
  const location = useLocation();
  const userState = useGetUser();
  const [locale, setLocale] = useState("en-US");
  const { data: userEntity } = userState;

  useEffect(() => {
    document.title = "ControlCenter";
  }, []);

  useEffect(() => {
    const linkEl =
      document.querySelector<HTMLLinkElement>("link[rel='icon']") ??
      (() => {
        const el = document.createElement("link");
        el.rel = "icon";
        document.head.appendChild(el);
        return el;
      })();
    const originalHref = linkEl.href;
    linkEl.href = DC_FAVICON_PATH;
    return () => {
      linkEl.href = originalHref;
    };
  }, []);

  useEffect(() => {
    const newLocale = Locale.getLocale();

    if (locale !== newLocale) {
      Locale.change(newLocale);
      setLocale(newLocale);
    }
  }, [locale]);

  useEffect(() => {
    TagManager.event({
      eventName: "page_view"
    });
  }, [location]);

  const { asAccount, asUser } = useParams();

  const { data: ccUserInfo } = useControlcenterAPIInterface({
    asAccount,
    asUser
  });

  useEffect(() => {
    Locale.setLabelsOnce(LABELS);
  }, []);

  if (!ccUserInfo) {
    return (
      <div data-testid="ddc-page">
        <MessagePage
          actionName={"Loading user permissions"}
          message="Loading user permissions"
        />
      </div>
    );
  }
  return (
    <ControlCenterContainer>
      <Outlet context={{ ccUserInfo, userEntity }} />
    </ControlCenterContainer>
  );
};
